/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Tue May 17 2022
*  File : shared.ts
*******************************************/

export type Callback = (err, data) => void;

export function promiseToCallback<T>(promise: Promise<T>, callback: Callback) : Promise<T> {
    return promise.then(
        c => {
            callback(null, c);
            return c;
        }
    ).catch(
        err => {
            callback(err, null);
            throw err;
        }
    );
}

export function tryToPromise<T>(
    functor: () => T,
    errorPackager: (err: any) => void = (err) => {
        return { message: err };
    }
): Promise<T> {
    try {
        return Promise.resolve( functor() );
    }
    catch(e) {
        return Promise.reject(errorPackager(e));
    }
}